import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PhoneIncoming, X } from "lucide-react";
import { telephonyApi } from "@/api";

export const IncomingCallPopup = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [enabled, setEnabled] = useState(false);
  useEffect(() => { telephonyApi.settings().then((s) => setEnabled(!!s.enabled && !!s.has_credentials)).catch(() => {}); }, []);
  useEffect(() => {
    if (!enabled) return undefined;
    const tick = () => telephonyApi.incoming().then(setEvents).catch(() => {});
    tick();
    const t = setInterval(tick, 6000);
    return () => clearInterval(t);
  }, [enabled]);
  const dismiss = async (e) => { await telephonyApi.seen(e.id); setEvents((x) => x.filter((y) => y.id !== e.id)); };
  if (!events.length) return null;
  return (
    <div className="fixed bottom-6 right-6 z-50 space-y-3" data-testid="incoming-calls">
      {events.map((e) => (
        <div key={e.id} className="w-96 rounded-xl border-2 border-brand-400 bg-white p-5 shadow-2xl" data-testid="incoming-call">
          <div className="flex items-start gap-3">
            <span className="rounded-full bg-brand-100 p-3 text-brand-800"><PhoneIncoming className="h-6 w-6 animate-pulse" /></span>
            <div className="min-w-0 flex-1">
              <div className="text-sm font-semibold uppercase tracking-wide text-brand-800">Příchozí hovor</div>
              <div className="truncate text-xl font-bold text-gray-900">{e.contact_name || "Neznámé číslo"}</div>
              <div className="text-base text-gray-700">{e.from_number}</div>
            </div>
            <button onClick={() => dismiss(e)} className="rounded-md p-1 text-gray-400 hover:bg-gray-100" data-testid="incoming-dismiss"><X className="h-5 w-5" /></button>
          </div>
          <div className="mt-3 flex gap-2">
            {e.contact_id ? <button onClick={() => { dismiss(e); navigate(`/contacts/${e.contact_id}`); }} className="btn-primary btn-sm" data-testid="incoming-open-contact">Otevřít kontakt</button>
              : <button onClick={() => { dismiss(e); navigate(`/contacts?search=${encodeURIComponent(e.from_number || "")}`); }} className="btn-secondary btn-sm">Hledat v kontaktech</button>}
          </div>
        </div>))}
    </div>
  );
};
